<script>
    import { onMount } from "svelte";
    import IconAdd from "../icons/IconAdd.svelte";
    import { CheeseTypeStore, Authentication } from '../stores'
	import CheeseType from "./CheeseType.svelte"
	import CheeseTypeCru from "./CheeseTypeCru.svelte"
    
    let cheeseTypeFromApi = [];
    let authenthicationData = '';
    let modal;
    let editSelectedCheeseType;

	onMount(async function () {
        loadCheeseTypes();
    });

    async function loadCheeseTypes() {
        await Authentication.subscribe((data) => authenthicationData = data);
        let url = 'MYURL/cheesetype';

        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
            }
        );
        const data = await response.json();

        // Put the data in the store
        CheeseTypeStore.set(data);
        CheeseTypeStore.subscribe((data) => cheeseTypeFromApi = data)
    }

    function addCheeseType() {
        editSelectedCheeseType = {id: 0, name: '', description: '', maturationDays: 0, pricePerKiloGram: 0.0, weigthLosPercent: 0.0};
        modal.show();
    }

    function editCheeseType(editedCheeseType) {
        editSelectedCheeseType = editedCheeseType.detail.editedCheeseTypeItem;
        modal.show();
    }
</script>

<nav>
    <ul>
        <li><h1>Käse-Typen</h1></li>
        <li><IconAdd on:clicked={addCheeseType}/></li>
    </ul>
</nav>

<CheeseTypeCru bind:this={modal} cheeseType={editSelectedCheeseType} on:accepted={loadCheeseTypes}/>

<div>
    {#each cheeseTypeFromApi as cheeseType}
        <CheeseType cheeseType={cheeseType} on:customerDeleted={loadCheeseTypes} on:editCheeseType={(editedCheeseType) => editCheeseType(editedCheeseType)}/>
    {/each}
</div>

<style>
    h1 {
        margin-left: -30px;
    }
    
    ul {
        display: flex;
        justify-content: flex;
        list-style: none;
        align-items: center;
    }

    li {
        display: block;
        margin-right: 1em;
    }

    nav {
        margin-top: -70px;
        margin-bottom: -20px;
    }
</style>